import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'

const COLORS = ['#474789', '#28D094', '#F1EA7F', '#FF4961', 'gray']

class PresupuestoColorLegenda extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeColor: null,
            porcentaje:  ConfigBusiness.get('periodoPresupuestario.porcentajeCorte'),
        }
    }

    getLabel(color) {
        const pct = this.state.porcentaje
        if (color === '#474789') return '100% del Presupuesto disponible'
        if (color === '#28D094') return 'Más del ' + pct + '% del Presupuesto disponible'
        if (color === '#F1EA7F') return 'Menos del ' + pct + '% del Presupuesto disponible'
        if (color === '#FF4961') return 'Sin Presupuesto Disponible o excedido'
        return 'Sin Presupuesto Asignado'
    }

    render() {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: '6px' }}>
                {COLORS.map(color => (
                    <div
                        key={color}
                        style={{ display: 'flex', alignItems: 'center', position: 'relative', cursor: 'default' }}
                        onMouseEnter={() => this.setState({ activeColor: color })}
                        onMouseLeave={() => this.setState({ activeColor: null })}
                    >
                        <div style={{ width: '16px', height: '16px', backgroundColor: color, borderRadius: '50%', marginRight: '4px' }}></div>
                        {this.state.activeColor === color && (
                            <span style={{
                                position:        'absolute',
                                top:             '20px',
                                right:           '0',
                                backgroundColor: '#fff',
                                padding:         '5px 8px',
                                borderRadius:    '5px',
                                boxShadow:       '0px 2px 5px rgba(0,0,0,0.2)',
                                whiteSpace:      'nowrap',
                                zIndex:          100,
                                fontSize:        '0.78rem',
                            }}>
                                {this.getLabel(color)}
                            </span>
                        )}
                    </div>
                ))}
            </div>
        )
    }
}

export default PresupuestoColorLegenda
